import kebabCase from 'lodash/kebabCase';

import { IVehicleFacet } from '~/composables/useBikeVehicleFacets';
import { slugifyFacetValue } from '~/helpers/bikePageViewModel';

export type BikeSelectorField = 'make' | 'model' | 'year';

export const BIKE_SELECTOR_FIELDS: BikeSelectorField[] = ['make', 'model', 'year'];

export interface IBikeSelectorOption {
  title: string;
  slug: string;
}

export type IBikeSelection = Partial<Record<BikeSelectorField, IBikeSelectorOption>>;

export interface IBikeSelectorOptions {
  makes?: IBikeSelectorOption[];
  models?: IBikeSelectorOption[];
  years?: IBikeSelectorOption[];
}

export interface IBikeSelectorChange {
  selection: IBikeSelection;
  field: BikeSelectorField;
}

export const toMakeOptions = (facets: IVehicleFacet[]): IBikeSelectorOption[] =>
  facets.map((facet) => ({ title: facet.title, slug: kebabCase(facet.value) }));

export const toModelOptions = (facets: IVehicleFacet[]): IBikeSelectorOption[] =>
  facets.map((facet) => ({ title: facet.title, slug: slugifyFacetValue(facet.value) }));

export const toYearOptions = (years: number[]): IBikeSelectorOption[] =>
  years.map((year) => ({ title: `${year}`, slug: `${year}` }));

export const getBikeRoute = ({ make, model, year }: IBikeSelection): string => {
  if (!make) return '/bikes';
  if (!model) return `/bikes/${make.slug}`;
  if (!year) return `/bikes/${make.slug}/${model.slug}`;
  return `/bikes/${make.slug}/${model.slug}/${year.slug}`;
};

export const isCompleteBikeSelection = ({ make, model, year }: IBikeSelection): boolean =>
  !!(make && model && year);
